import Vue from "vue";
import App from "./App.vue";
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import router from "./router";
// import store from "./store";
// import image from "../components/image.vue"

// 解决IE浏览器上出现[vue-router] Failed to resolve async component default: ReferenceError: “Promise”未定义 这是由于es6语法解析不成功造成的
import 'babel-polyfill';
import "es6-promise/auto";

import tipconNav from '../com/tipconNav.vue';
import headerview from '../com/headerview.vue';
import banner from '../components/banner/banner.vue';
import footview from '../components/footview/footview.vue';
import { httpGet, httpTokenGet, httpPost, httpTokenPost, httpPut, httpTokenPut, httpDelete, staticDomainURL, onScrollT } from "./utils/request.js"
Vue.prototype.$get = httpGet;
Vue.prototype.$post = httpPost;
Vue.prototype.$tokenGet = httpTokenGet;
Vue.prototype.$tokenPost = httpTokenPost;
Vue.prototype.$put = httpPut;
Vue.prototype.$tokenPut = httpTokenPut;
Vue.prototype.$del = httpDelete;
Vue.prototype.$imgUrl = staticDomainURL;
Vue.prototype.$onScrollT = onScrollT;
// Vue.prototype.$defult = require('../static/index/grzx.png')
// Vue.component("image", image);
Vue.component('tipconNav', tipconNav);
Vue.component("headerview", headerview);
Vue.component("banner", banner);
Vue.component("footview", footview);

Vue.config.productionTip = false;
Vue.use(Element)

//用改变浏览器页签名称
router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})

import api from './utils/request.js';
Vue.prototype.$api = api;


new Vue({
    router,
    // store,
    render: h => h(App)
}).$mount("#app");